import React from "react";
import "./ServicesModal.css";
import ListTemplateModal from "../../../ListTemplateModal/ListTemplateModal";
import RiseModal from "../../../RiseModal/RiseModal";
import TreeItem from "../TreeItem/TreeItem";
import { Link } from "react-router-dom";

const ServicesModal = (props) => {
  return (
    <RiseModal {...props}>
      <div className="services__modal">
        <TreeItem
          text="Individual Services"
          Modal={
            <ListTemplateModal
              closeOnLeave={true}
              items={[
                { title: "Advance Tax Planning", url: "/tax-planning-service" },
                {
                  title: "Preparation of Federal and State Tax Returns",
                  url: "/tax-returns-service",
                },
                {
                  title: "Filing of Amendment Tax Returns/ Claim for refund",
                  url: "/irs-audit-service",
                },
                {
                  title: "Preparation of ITIN (Form W7) applications",
                  url: "/itin-service",
                },
                {
                  title: "Extension of Tax Returns",
                  url: "/extension-service",
                },
                { title: "Payroll Services", url: "/payroll-service" },
              ]}
            />
          }
        />
        <TreeItem
          text="Resources"
          Modal={
            <ListTemplateModal
              closeOnLeave={true}
              items={[
                {
                  title: "FBAR – Foreign Bank Account Reporting",
                  url: "/fbar-service",
                },
                {
                  title: "Foreign Account Tax Compliance Act (FATCA Form 8938)",
                  url: "/fatca-service",
                },
                {
                  title: "Non-resident Alien",
                  url: "/alien-service",
                },
              ]}
            />
          }
        />
        <Link className="ltm__item" to="#">
          Business Service
        </Link>
      </div>
    </RiseModal>
  );
};

export default ServicesModal;
